import { render, staticRenderFns } from "./InputContent.vue?vue&type=template&id=3248f4cc&scoped=true&lang=pug&"
import script from "./InputContent.vue?vue&type=script&lang=js&"
export * from "./InputContent.vue?vue&type=script&lang=js&"
import style0 from "./InputContent.vue?vue&type=style&index=0&id=3248f4cc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3248f4cc",
  null
  
)

/* custom blocks */
import block0 from "./InputContent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports